import React from 'react'
import classes from './About.module.css'
import profilepic from '../img/user/adarsh-photo.png'
import { NavLink } from 'react-router-dom'
import MetaTags from 'react-meta-tags';

function About(props) {
  return (
    <div className={classes.container}>
    <MetaTags>
      <title>About</title>
      <meta name="description" content="Some description." />
      <meta property="og:title" content="MyApp" />
      <meta property="og:image" content="path/to/image.jpg" />
    </MetaTags>       
    {/* <div className={classes.header}>
      <li><a href="#"><NavLink to="/"><img className={classes.preview} src={require("../img/icons/home.png")} alt="" /></NavLink></a></li>
      </div> */}
        <div className={classes.header}>
        <h1>About<span className={classes.dot}></span></h1>
        <li onClick={props.Onclose}><a href="#"><NavLink to="/"><img className={classes.preview} src={require("../img/icons/home.png")} alt="" /></NavLink></a></li>
        </div>
      <div className={classes.partition}>
        <div className={classes.Aboutleft}>
          <div className={classes.contentsLeft}>
          {/* <div className={classes.AboutText}>
          <p>About<span className={classes.dot}></span></p>
          </div> */}
         <div className={classes.profile}>
           <img src={profilepic} alt="profile-photo" />
         </div>
          </div>
        </div>
        <div className={classes.Aboutright}>
          <div className={classes.contentsRight}>
          <p></p>
          <p>Electronics And Communication Engineering Graduate From 
            CMS College Of Engineering And Technology,Coimbatore Under 
            Anna University Chennai.I Have Been Doing Node Js Web Development 
            For Last One Year And I Specialized To Build A Web Application For 
            Business Requirements.</p>
          </div>
        </div>
        </div>
    </div>
  )
}

export default About